import React, { useState, useEffect , useCallback} from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";


import Loader from "../components/Loader";
import ErrorMessage from "../components/ErrorMessage";
import Model3DViewer from "../components/Model3DViewer";

import image from "../components/fooditem2.png";

import apiService from "../services/api";

import "../styles/global.css";
import "../styles/restaurantMenu.css";

import chikenImage from "../assets/chicken-leg.png";
import pizzaImage from "../assets/pizza.png";
import food from "../assets/food.png";
import donut from "../assets/donut.png";
import drink from "../assets/glass-cup.png";
import potato from "../assets/potato-fries.png";
import sandwich from "../assets/sandwich.png";
import soup from "../assets/soup.png";
import taco from "../assets/tacos.png";


/* ===============================
   ICON IMPORTS
================================ */

import {
  MapPin,
  Search,
  Utensils,
  // Coffee,
  // Salad,
  // Cake,
  Star,
  StarHalf,
  // Pizza,
  // IceCream,
  // Soup,
  // Sandwich,
  // Drumstick,
  Clock,
  Camera,
} from "lucide-react";

/* ===============================
   MAIN COMPONENT
================================ */

export default function RestaurantMenu() {

  const BASE_API = process.env.REACT_APP_API_URL || "https://scanmymenu-nm38.onrender.com";

  /* ===============================
     ROUTER
  ============================== */

  const [searchParams] = useSearchParams();

  const navigate = useNavigate();

  const [searchQuery, setSearchQuery] = useState("");
  const [submittedQuery, setSubmittedQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [foodTypeFilter, setFoodTypeFilter] = useState(""); // "", "veg", "non-veg"

  const restaurantId =
    searchParams.get("id");

  /* ===============================
     STATE
  ============================== */

  const [restaurant,
    setRestaurant] =
    useState(null);

  const [loading,
    setLoading] =
    useState(true);

  const [error,
    setError] =
    useState(null);


  const [selectedCategory,
    setSelectedCategory] =
    useState(null);

  const [selectedModel,
    setSelectedModel] =
    useState(null);

  /* ===============================
     FETCH DATA
  ============================== */

const fetchRestaurantDetails =
useCallback(async () => {

  try {

    setLoading(true);

    setError(null);

    const response =
      await apiService
        .getRestaurantByUserId(
          restaurantId
        );



        sessionStorage.setItem(
  "restaurantData",
  JSON.stringify(response)
);

    /* ===============================
       FILTER ONLY USER REQUIRED DATA
    ============================== */

  const userRestaurantData = {

  restaurantName:
    response.restaurantName,

  restaurantAddress:
    response.restaurantAddress,

  openingTime:
    response.openingTime,

  closingTime:
    response.closingTime,

  category:
    response.category,

  logoUrl:
    response.logoUrl,

  items:
    response.items?.map(
      (item) => ({

        itemId:
          item.itemId,

        name:
          item.name,

        description:
          item.description,

        price:
          item.price,

        category:
          item.category,

        ingredients:
          item.ingredients || [],

        prepTime:
          item.prepTime,

        type:
          item.type,

        calories:
          item.calories,

        imageUrl:
          item.imageUrl,

        modelUrl:
          item.modelUrl,

        createdAt:
          item.createdAt,

      })
    ) || []

};

    /* ===============================
       SET FILTERED DATA
    ============================== */



    setRestaurant(userRestaurantData);


  }

catch (err) {

  console.error(err);

  /*
  BACKEND MESSAGE
  */

  if (
    err.response &&
    err.response.data &&
    err.response.data.message
  ) {

    setError(
      err.response.data.message
    );

  }
  else {

    setError(
      "Failed to load menu"
    );

  }

}

  finally {

    setLoading(false);

  }

}, [restaurantId]);

useEffect(() => {

  if (!restaurantId) {

    setError(
      "No restaurant ID provided"
    );

    setLoading(false);

    return;

  }

  fetchRestaurantDetails();

}, [restaurantId, fetchRestaurantDetails]);



useEffect(() => {

  const increaseScan =
    async () => {

      try {

        const alreadyScanned =
          localStorage.getItem(
            `scan_${restaurantId}`
          );

        if (alreadyScanned)
          return;

        await axios.put(
          `${BASE_API}/api/restaurants/${restaurantId}/increase-scan`
        );

        localStorage.setItem(
          `scan_${restaurantId}`,
          "true"
        );

      }

      catch (error) {

        console.log(
          "Scan count error",
          error
        );

      }

    };

  if (restaurantId) {

    increaseScan();

  }

}, [restaurantId, BASE_API]);


  /* ===============================
     HANDLE CLICK
  ============================== */

  const handleItemClick =
    (item) => {

      navigate(
        `/item/${item.itemId}`,
        {
          state: {
            item,
            restaurantId,
          },
        }
      );

    };

  /* ===============================
     CATEGORY ICON FUNCTION
  ============================== */

  // const getCategoryIcon =
  //   (category) => {

  //     if (!category)
  //       return <Utensils size={16} />;

  //     const name =
  //       category.toLowerCase();

  //     if (name.includes("drink"))
  //       return <Coffee size={16} />;

  //     if (name.includes("salad"))
  //       return <Salad size={16} />;

  //     if (name.includes("dessert"))
  //       return <Cake size={16} />;

  //     if (name.includes("pizza"))
  //       return <Pizza size={16} />;

  //     if (name.includes("ice"))
  //       return <IceCream size={16} />;

  //     if (name.includes("soup"))
  //       return <Soup size={16} />;

  //     if (name.includes("sandwich"))
  //       return <Sandwich size={16} />;

  //     if (name.includes("chicken"))
  //       return <Drumstick size={16} />;

  //     return <Utensils size={16} />;

  //   };

  /* ===============================
     CATEGORY LIST
  ============================== */

  const categories =
    Array.from(
      new Set(
        restaurant?.items
          ?.map(
            (item) =>
              item.category
          )
          .filter(Boolean)
      )
    )

      .sort(
        (a, b) => {

          const countA =
            restaurant.items
              .filter(
                (item) =>
                  item.category === a
              ).length;

          const countB =
            restaurant.items
              .filter(
                (item) =>
                  item.category === b
              ).length;

          return countB - countA;

        }
      );

  /* ===============================
     FILTER ITEMS
  ============================== */


  useEffect(() => {

  if (!restaurant?.items) return;

  const query =
    searchQuery.toLowerCase().trim();

  if (!query) {
    setSuggestions([]);
    return;
  }

  const words =
    restaurant.items.flatMap(item => [
      item.name,
      item.category,
      item.type
    ]);

  const uniqueSuggestions =
    [...new Set(words)]
      .filter(word =>
        word?.toLowerCase().includes(query)
      )
      .slice(0, 5);

  setSuggestions(uniqueSuggestions);

}, [searchQuery, restaurant]);


const filteredItems =
  restaurant?.items?.filter((item) => {

    const query = submittedQuery.toLowerCase().trim();

    const matchesText =
      !query ||
      item.name?.toLowerCase().includes(query) ||
      item.category?.toLowerCase().includes(query);

    const matchesTypeSearch =
      !query ||
      item.type?.toLowerCase() === query;

    const matchesCategory =
      !selectedCategory ||
      item.category === selectedCategory;

    // 🔥 NEW VEG/NON-VEG FILTER
    const matchesFoodType =
      foodTypeFilter === ""
        ? true
        : item.type?.toLowerCase() === foodTypeFilter;

    return (
      (matchesText || matchesTypeSearch) &&
      matchesCategory &&
      matchesFoodType
    );

  }) || [];

  const handleKeyDown =
  (e) => {

    if (e.key === "Enter") {

      setSubmittedQuery(
        searchQuery
      );

      setShowSuggestions(false);

    }

  };

  /* ===============================
     LOADING
  ============================== */

  if (loading)
    return <Loader />;

  /* ===============================
     ERROR
  ============================== */

  if (error || !restaurant)

    return (

      <ErrorMessage

        message={
          error ||
          "Restaurant not found"
        }

      />

    );

  /* ===============================
     UI
  ============================== */

  return (

    <div className="menu-container">

      {/* ===============================
         HEADER
      ============================== */}
<div className="restaurant-banner">

  {/* RANDOM FOOD BACKGROUND */}
  <div className="food-pattern-random">
    <span className="food-icon i1"><img src={pizzaImage} alt="Pizza" style={{width:"22px"}}/></span>
    <span className="food-icon i2"><img src={chikenImage} alt="Chicken" style={{width:"22px"}}/></span>
    <span className="food-icon i3"><img src={potato} alt="Potato Fries" style={{width:"22px"}}/></span>
    <span className="food-icon i4"><img src={soup} alt="Soup" style={{width:"22px"}}/></span>
    <span className="food-icon i5"><img src={sandwich} alt="Sandwich" style={{width:"22px"}}/></span>
    <span className="food-icon i6"><img src={food} alt="Food" style={{width:"22px"}}/></span>
    <span className="food-icon i7"><img src={donut} alt="Donut" style={{width:"22px"}}/></span>
    <span className="food-icon i9"><img src={taco} alt="Taco" style={{width:"22px"}}/></span>
    <span className="food-icon i10"><img src={drink} alt="Drink" style={{width:"22px"}}/></span>
  </div>

  {/* WAVES */}
  <div className="banner-waves">

    <svg
      className="wave wave-back"
      viewBox="0 0 1440 320"
      preserveAspectRatio="none"
    >
      <path
        d="
          M0,200
          C360,420
          720,-40
          720,200
          C1080,440
          1440,-60
          1440,200
          L1440,320
          L0,320
          Z
        "
      />
    </svg>

    <svg
      className="wave wave-front"
      viewBox="0 0 1440 380"
      preserveAspectRatio="none"
    >
      <path
        d="
          M0,300
          C340,20
          480,420
          720,260
          C960,10
          1200,600
          1440,300
          L1440,420
          L0,420
          Z
        "
      />
    </svg>

  </div>

  {/* HEADER */}
  <div className="banner-header">

    <div className="logo-box">
      <Utensils size={26} />
    </div>

    <div className="banner-details">

      <h1>
        {restaurant.restaurantName}
      </h1>

      <div className="veg-badge">
        {restaurant.category === "Veg" ? "Pure Veg" : restaurant.category}
      </div>

      <p style={{color:"white"}}>
        <MapPin size={16} />
        {restaurant.restaurantAddress}
      </p>

    </div>

  </div>

  {/* RIGHT SIDE FOOD IMAGE */}
  <div className="banner-food-image">

    <img
      src={image}
      alt="Food"
    />

  </div>

  {/* STATS */}
  <div className="restaurant-stats">

    <div className="stat">
      <div className="stat-icon">
        <Star size={16} fill="gold" stroke="gold" />
        <Star size={16} fill="gold" stroke="gold" />
        <Star size={16} fill="gold" stroke="gold" />
        <Star size={16} fill="gold" stroke="gold" />
        <StarHalf size={16} fill="gold" stroke="gold" />
      </div>

      <div>
        <span>4.5 </span>
        <small>Rating</small>
      </div>
    </div>

    <div className="stat-divider" />

    <div className="stat">
      <Clock size={16} />
      <span>
        {restaurant.openingTime} AM
      </span>
      <small>Opening</small>
    </div>

    <div className="stat-divider" />

    <div className="stat">
      <Clock size={16} />
      <span>
        {restaurant.closingTime} PM
      </span>
      <small>Closing</small>
    </div>

  </div>

</div>


      {/* ===============================
         SEARCH
      ============================== */}

 <div className="search-filter-row">

  {/* 🔍 SEARCH */}
  <div className="search-bar">
    <Search className="search-icon" size={18} />

    <input
      type="text"
      placeholder="Search food..."
      value={searchQuery}
      onChange={(e) => {
        setSearchQuery(e.target.value);
        setShowSuggestions(true);
      }}
      onKeyDown={handleKeyDown}
    />

    {showSuggestions && suggestions.length > 0 && (
      <div className="suggestions-box">
        {suggestions.map((suggestion, index) => (
          <div
            key={index}
            className="suggestion-item"
            onClick={() => {
              setSearchQuery(suggestion);
              setSubmittedQuery(suggestion);
              setShowSuggestions(false);
            }}
          >
            {suggestion}
          </div>
        ))}
      </div>
    )}
  </div>

  {/* 🔽 VEG/NON-VEG SELECT */}
  <select
    value={foodTypeFilter}
    onChange={(e) => setFoodTypeFilter(e.target.value)}
    className="filter-select"
  >
    <option value=""> All</option>
    <option value="veg"> Veg</option>
    <option value="non-veg"> Non-Veg</option>
  </select>

</div>


      {/* ===============================
         CATEGORY BUTTONS
      ============================== */}

      <div className="category-scroll">

        <button
          className={
            !selectedCategory
              ? "active"
              : ""
          }
          onClick={() =>
            setSelectedCategory(
              null
            )
          }
        >
{/* 
          <Utensils size={16} /> */}

          All

        </button>

        {categories.map(
          (category, index) => (

            <button
              key={index}
              className={
                selectedCategory ===
                category
                  ? "active"
                  : ""
              }
              onClick={() =>
                setSelectedCategory(
                  category
                )
              }
            >

            

              {category}

            </button>

          )
        )}

      </div>

      {/* ===============================
         CATEGORY GROUPS
      ============================== */}

{categories.map((category) => {

  // IMPORTANT FIX
  if (selectedCategory && category !== selectedCategory) {
    return null;
  }

  const categoryItems =
    filteredItems.filter(
      (item) =>
        item.category === category
    );

          if (
            categoryItems.length === 0
          )
            return null;

          return (

            <div
              key={category}
              className="category-section"
            >

              <div className="category-header">

              <div style={{display:"flex",alignItems:"baseline", gap:"5px"}}>
                <div >
                  <span
                      style={{
                        width: "4px",
                        height: "18px",
                        backgroundColor: "orange",
                        borderRadius: "4px",
                        color:"orange",
                        padding:"0",
                        fontSize:"14px",
                      }}
                    >l</span>
                    </div>
                <h3 >

                  {category}

                </h3>
              </div>

                <button
                  className="view-all-btn"
                  onClick={() =>
                    navigate(
                      `/category/${category}`,
                      {
                        state: {
                          restaurantId,
                          category
                        }
                      }
                    )
                  }
                >

                  <span className="view-all">
                  View all
                  </span>

                </button>

              </div>

              <div className="items-row">

                {categoryItems.map(
                  (item) => (

                    <div
                      key={
                        item.itemId
                      }
                      className="food-card"
                      onClick={() =>
                        handleItemClick(
                          item
                        )
                      }
                    >

                      <img
                        src={
                          item.imageUrl
                        }
                        alt={
                          item.name
                        }
                      />

                      <div className="food-info">

                        <h4>

                          <Star
                            size={14}
                            className="food-star"
                          />

                          {
                            item.name
                          }

                        </h4>
{/* 
                        <p>

                          {
                            item.description
                          }

                        </p> */}

                        <span className="price">

                          ₹
                          {
                            item.price
                          }

                        </span>

                      </div>

                    </div>

                  )
                )}

              </div>

            </div>

          );

        }
      )}


{/* FLOATING AR CAMERA BUTTON */}

<button
  className="floating-camera-btn"
  onClick={() => navigate("/ar-camera")}
>
  {/* PULSE RINGS */}
  <span className="pulse-ring ring1"></span>
  <span className="pulse-ring ring2"></span>

  {/* SPARKLES */}
  <span className="spark s1"></span>
  <span className="spark s2"></span>
  <span className="spark s3"></span>

  {/* CAMERA ICON */}
  <div className="camera-inner">
    <Camera size={30} />
  </div>

  {/* AR BADGE */}
  {/* <span className="ar-badge">AR</span> */}
</button>

      {/* ===============================
         MODEL VIEWER
      ============================== */}

      {selectedModel && (

        <div
          className="modal"
          onClick={() =>
            setSelectedModel(
              null
            )
          }
        >

          <div
            className="modal-content"
            onClick={(e) =>
              e.stopPropagation()
            }
          >

            <button
              className="close-btn"
              onClick={() =>
                setSelectedModel(
                  null
                )
              }
            >

              ✕

            </button>

            <Model3DViewer
              modelUrl={
                selectedModel
              }
              fullScreen
            />

          </div>

        </div>

      )}

    </div>

  );

}